import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { Container, media } from 'styled-bootstrap-grid';
import { EditOthers, EditServiceProvider, EditTeamMembers, Layout } from '@components/team';
import { RoleEnum } from 'constants/enums';

const EditProfile = () => {
    var _userData = JSON.parse(localStorage.getItem('user') || '{}');

    return (
        <Wrapper>
            <Routes>
                {_userData.user_login == RoleEnum.SERVICEPROVIDER && (
                    <Route path="/" element={<EditServiceProvider />} />
                )}
                {_userData.user_login == RoleEnum.TEAMMEMBER && (
                    <Route path="/" element={<EditTeamMembers />} />
                )}
                {_userData.user_login == RoleEnum.OTHERS && (
                    <Route path="/" element={<EditOthers />} />
                )}
            </Routes>
        </Wrapper>
    );
};

const Wrapper = styled(Container)`
    padding: 0px;
    height: 100%;

    ${media.xs`
	display: block !important;
    `}
    ${media.sm`
    display: block !important;
    `}
    ${media.md`
    display: flex !important;
    margin:0;
    min-width:100%;
    `}
    ${media.lg`
    display: flex !important;
    `}
`;

EditProfile.Layout = Layout;
export default EditProfile;
